import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveItineraryFacility,
  createItineraryFacility,
  deleteItineraryFacility,
  getAllActiveItineraryFacility,
  getAllItineraryFacility,
  getItineraryFacilityByID,
  itineraryFacilityImageUpload,
  updateItineraryFacility,
} from "./services/itineraryfacility.services";
import {
  IItineraryFacilityInitialState,
  IItineraryFacility,
} from "./itineraryfacilityModel";

const initialState: IItineraryFacilityInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ItineraryFacilityList: [],
  ItineraryFacilityID: null,
  ItineraryFacilityDetail: {
    Name: "",
    FacilityImage: "",
    IsActive: 1,
  },
};

const itineraryfacilitySlice = createSlice({
  name: "itineraryfacility",
  initialState,
  reducers: {
    clearItineraryFacilityDetails: (state) => {
      state.ItineraryFacilityDetail = initialState.ItineraryFacilityDetail;
    },
    setItineraryFacilityID: (state, action) => {
      state.ItineraryFacilityID = action.payload;
    },
    clearItineraryFacilityID: (state) => {
      state.ItineraryFacilityID = initialState.ItineraryFacilityID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllItineraryFacility.fulfilled,
      (state, action: PayloadAction<IItineraryFacility[]>) => {
        state.loading = false;
        state.ItineraryFacilityList = action.payload || [];
      }
    );
    builder.addCase(getAllItineraryFacility.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ItineraryFacilityList = [];
    });
    builder.addCase(createItineraryFacility.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createItineraryFacility.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createItineraryFacility.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateItineraryFacility.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateItineraryFacility.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateItineraryFacility.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteItineraryFacility.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteItineraryFacility.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getItineraryFacilityByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      getItineraryFacilityByID.fulfilled,
      (state, action: any) => {
        state.formLoading = false;
        state.ItineraryFacilityDetail = action.payload;
      }
    );
    builder.addCase(getItineraryFacilityByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ItineraryFacilityDetail = initialState.ItineraryFacilityDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveItineraryFacility.fulfilled,
      (state, action: PayloadAction<IItineraryFacility[]>) => {
        state.loading = false;
        state.ItineraryFacilityList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveItineraryFacility.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ItineraryFacilityList = [];
    });
    builder.addCase(ActiveInactiveItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveItineraryFacility.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      ActiveInactiveItineraryFacility.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );

    builder.addCase(itineraryFacilityImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(itineraryFacilityImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(itineraryFacilityImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearItineraryFacilityDetails,
  clearItineraryFacilityID,
  setItineraryFacilityID,
} = itineraryfacilitySlice.actions;
export default itineraryfacilitySlice.reducer;
